<app-nexleader-cookies-acknowledge></app-nexleader-cookies-acknowledge>
<app-nexleader-nav></app-nexleader-nav>
<div class="view-container" style="height: 100%">
    <router-outlet class="nexleaderFull animate-panel" data-effect="fadeIn" data-child="content">
    </router-outlet>
</div>